import React, { forwardRef } from 'react';

import { useTggTheme } from '../../contexts';

import { StyledPinoIconButton } from './PinoIconButton.styled';
import { IconButtonProperties } from './PinoIconButton.types';

export const PinoIconButton = forwardRef(
    (
        {
            size = 'medium',
            onClick,
            buttonLocation = 'table',
            ...otherParameters
        }: IconButtonProperties,
        reference?: React.ForwardedRef<HTMLButtonElement>,
    ) => {
        const { theme } = useTggTheme();
        const commonButtonProperties = {
            $size: size,
            onClick,
            ref: reference,
            $buttonLocation: buttonLocation,
            ...otherParameters,
        };

        return (
            <StyledPinoIconButton {...commonButtonProperties} theme={theme}>
                {commonButtonProperties.children}
            </StyledPinoIconButton>
        );
    },
);

PinoIconButton.displayName = 'Button';

export default PinoIconButton;
